var map = {
	"./CanvasClear": 74,
	"./CanvasClear.js": 74,
	"./CanvasMove": 75,
	"./CanvasMove.js": 75,
	"./CommandAbstract": 25,
	"./CommandAbstract.js": 25,
	"./ComponentDelete": 76,
	"./ComponentDelete.js": 76,
	"./ComponentEnter": 77,
	"./ComponentEnter.js": 77,
	"./ComponentExit": 78,
	"./ComponentExit.js": 78,
	"./ComponentNext": 79,
	"./ComponentNext.js": 79,
	"./ComponentPrev": 80,
	"./ComponentPrev.js": 80,
	"./ComponentStyleClear": 81,
	"./ComponentStyleClear.js": 81,
	"./CopyComponent": 82,
	"./CopyComponent.js": 82,
	"./CreateComponent": 27,
	"./CreateComponent.js": 27,
	"./DeleteComponent": 28,
	"./DeleteComponent.js": 28,
	"./Drag": 41,
	"./Drag.js": 41,
	"./ExportTemplate": 26,
	"./ExportTemplate.js": 26,
	"./Fullscreen": 38,
	"./Fullscreen.js": 38,
	"./MoveComponent": 29,
	"./MoveComponent.js": 29,
	"./OpenAssets": 35,
	"./OpenAssets.js": 35,
	"./OpenBlocks": 34,
	"./OpenBlocks.js": 34,
	"./OpenLayers": 31,
	"./OpenLayers.js": 31,
	"./OpenStyleManager": 32,
	"./OpenStyleManager.js": 32,
	"./OpenTraitManager": 33,
	"./OpenTraitManager.js": 33,
	"./PasteComponent": 83,
	"./PasteComponent.js": 83,
	"./Preview": 39,
	"./Preview.js": 39,
	"./Resize": 40,
	"./Resize.js": 40,
	"./SelectComponent": 11,
	"./SelectComponent.js": 11,
	"./SelectParent": 37,
	"./SelectParent.js": 37,
	"./SelectPosition": 18,
	"./SelectPosition.js": 18,
	"./ShowOffset": 36,
	"./ShowOffset.js": 36,
	"./SwitchVisibility": 30,
	"./SwitchVisibility.js": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;